import "../../../assets/presentation/components/modal-views/drop-down-CevdB4q0.css";
import { ViewPortBreakpoint } from "../../../domain/view-port/view-port-breakpoints.js";
import { useCoreSelector } from "../../../redux/config.js";
import { useFirstRender } from "../../hooks/use-first-render.js";
import { selectViewPort } from "../../../redux/view-port/selectors.js";
import { AnchorType } from "../../../domain/modal-view/modal-view.js";
import { ModalView, ModalViewAnchor, ModalViewContainer, ModalViewLayout, ModalViewScrim } from "./modal-view2.js";
/* empty css          */
import classNames from "classnames";
import { forwardRef, useEffect } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/modal-views/drop-down.tsx
var CompatibilityConstants = /* @__PURE__ */ function(CompatibilityConstants) {
	CompatibilityConstants[CompatibilityConstants["COMPAT_MODE_MAX_WIDTH"] = ViewPortBreakpoint.SMARTPHONE] = "COMPAT_MODE_MAX_WIDTH";
	CompatibilityConstants[CompatibilityConstants["COMPAT_MODE_FRAME_OFFSET"] = 20] = "COMPAT_MODE_FRAME_OFFSET";
	return CompatibilityConstants;
}(CompatibilityConstants || {});
var DropDown = forwardRef(({ anchor, children, className, constraint, isPending, hide, useFullConstraintWidth = false, allowDefaultMobileStyles = true, ...otherProps }, ref) => {
	const firstRender = useFirstRender();
	const viewPort = useCoreSelector(selectViewPort());
	useEffect(() => {
		const onResize = () => {
			if (!firstRender) hide?.();
		};
		window.addEventListener("resize", onResize);
		onResize();
		return () => {
			window.removeEventListener("resize", onResize);
		};
	}, [viewPort]);
	const style = {
		container: {},
		layout: {}
	};
	const type = anchor?.type ? anchor.type : AnchorType.CENTER;
	const viewPortCenterX = viewPort.width / 2;
	const viewPortCenterY = viewPort.height / 2;
	const offset = anchor?.offset ?? 0;
	let orientationX = "rtl";
	let orientationY = "ttb";
	const anchorRectLeft = anchor?.rect?.left ?? 0;
	const anchorRectRight = anchor?.rect?.right ?? 0;
	const anchorRectBottom = anchor?.rect?.bottom ?? 0;
	const anchorRectTop = anchor?.rect?.top ?? 0;
	const anchorRectHeight = anchor?.rect?.height ?? 0;
	const anchorRectWidth = anchor?.rect?.width ?? 0;
	if (type === AnchorType.BOTTOM_LEFT) {
		style.layout.left = anchor?.rect?.left;
		style.layout.top = anchor?.rect?.bottom;
		orientationX = anchorRectLeft > viewPortCenterX ? "rtl" : "ltr";
		orientationY = anchorRectBottom > viewPortCenterY ? "btt" : "ttb";
	} else if (type === AnchorType.BOTTOM_RIGHT) {
		style.layout.left = anchorRectRight;
		style.layout.top = anchorRectBottom;
		orientationX = anchorRectRight > viewPortCenterX ? "rtl" : "ltr";
		orientationY = anchorRectBottom > viewPortCenterY ? "btt" : "ttb";
	} else if (type === AnchorType.CENTER) {
		const centerY = anchorRectBottom - anchorRectHeight / 2;
		const centerX = anchorRectRight - anchorRectWidth / 2;
		style.layout.left = centerX;
		style.layout.top = centerY;
		orientationX = centerX > viewPortCenterX ? "rtl" : "ltr";
		orientationY = centerY > viewPortCenterY ? "btt" : "ttb";
	} else if (type === AnchorType.TOP_LEFT) {
		style.layout.left = anchorRectLeft;
		style.layout.top = anchorRectTop;
		orientationX = anchorRectLeft > viewPortCenterX ? "rtl" : "ltr";
		orientationY = anchorRectTop > viewPortCenterY ? "btt" : "ttb";
	} else if (type === AnchorType.TOP_RIGHT) {
		style.layout.left = anchorRectRight;
		style.layout.top = anchorRectTop;
		orientationX = anchorRectRight > viewPortCenterX ? "rtl" : "ltr";
		orientationY = anchorRectTop > viewPortCenterY ? "btt" : "ttb";
	} else if (type === AnchorType.VERTICAL_RIGHT) if (anchorRectBottom + offset < viewPortCenterY) {
		style.layout.top = anchorRectBottom + offset;
		style.layout.left = anchorRectRight;
		orientationY = "ttb";
		orientationX = anchorRectRight > viewPortCenterX ? "rtl" : "ltr";
	} else {
		style.layout.left = anchorRectRight;
		style.layout.top = anchorRectTop - offset;
		orientationX = anchorRectRight > viewPortCenterX ? "rtl" : "ltr";
		orientationY = "btt";
	}
	else if (type === AnchorType.VERTICAL_LEFT) if (anchorRectBottom + offset < viewPortCenterY) {
		style.layout.top = anchorRectBottom + offset;
		style.layout.left = anchorRectLeft;
		orientationY = "ttb";
		orientationX = anchorRectLeft > viewPortCenterX ? "rtl" : "ltr";
	} else {
		style.layout.left = anchorRectLeft;
		style.layout.top = anchorRectTop - offset;
		orientationX = anchorRectLeft > viewPortCenterX ? "rtl" : "ltr";
		orientationY = "btt";
	}
	if (constraint?.width) style.container.maxWidth = constraint.width;
	if (viewPort.width < CompatibilityConstants.COMPAT_MODE_MAX_WIDTH && allowDefaultMobileStyles) {
		style.layout.left = 20;
		style.layout.right = "auto";
		style.container.width = viewPort.width - 40;
		style.container.maxWidth = viewPort.width - 40;
		orientationX = "ltr";
	}
	const fullConstrainsWidth = {
		width: anchor?.rect?.width,
		maxWidth: anchor?.rect?.width
	};
	const onScrimClick = () => {
		hide?.();
	};
	return /* @__PURE__ */ jsxs(ModalView, {
		...otherProps,
		ref,
		className: classNames(className, "drop-down"),
		children: [/* @__PURE__ */ jsx(ModalViewScrim, { onClick: onScrimClick }), /* @__PURE__ */ jsx(ModalViewLayout, {
			style: useFullConstraintWidth && viewPort.breakpoint === ViewPortBreakpoint.SMARTPHONE ? {
				...style.layout,
				left: "12px"
			} : style.layout,
			children: /* @__PURE__ */ jsx(ModalViewAnchor, { children: /* @__PURE__ */ jsx(ModalViewContainer, {
				className: classNames(orientationX, orientationY),
				isPending,
				style: useFullConstraintWidth ? fullConstrainsWidth : style.container,
				children
			}) })
		})]
	});
});
var DropDownContent = ({ children, className }) => /* @__PURE__ */ jsx("div", {
	className: classNames(className, "content"),
	children
});
var DropDownHeader = ({ children, className }) => /* @__PURE__ */ jsx("div", {
	className: classNames(className, "header"),
	children
});
//#endregion
export { DropDown, DropDownContent, DropDownHeader };

//# sourceMappingURL=drop-down2.js.map